import React from 'react'
import cx from 'classnames'
import './loader.scss'

export const DefaultLoader = props => (
    <div className={cx('default-loader', props.className)} role="status">
        <span className="sr-only">Loading...</span>
        <div className="rect1" />
        <div className="rect2" />
        <div className="rect3" />
        <div className="rect4" />
        <div className="rect5" />
    </div>
)
